<template>
  <div class="page-wrapper" style="padding-top: 0">
    <h4 class="mb8">收款信息</h4>
    <Table :columns="column" :data="receiptBillList" class="mb32" ></Table>
    <div class="tips1">{{receiptBillTips}}</div>
    <br/>
    <br/>
    <h4 class="mb8" v-if="dataPay">付款信息</h4>
    <Table :columns="columnPay" :data="dataPay" class="mb32" ></Table>

    <h4 class="mb8" v-if="bookInfo && bookInfo.userType == 3">客户储蓄账户信息</h4>
    <Table :columns="columnAccount" :data="bookInfos" class="mb32"  v-if="bookInfo && bookInfo.userType == 3"></Table>

    <pay-detail :n="payDetailKey" :paymentFid="paymentFid" ></pay-detail>
  </div>
</template>

<script>
  import { repayment } from "../../../../../../api/book";
  import {formatDateTime} from "../../../../../../utils/format";
  import {getReservationDetail ,getReservationBills, getReservationText} from "../../../../../../api/book";
  import PayDetail from './PayDetail'


  export default {
    name: "BillInfo",
    props: {
      bookInfo: {
        type: Object,
        default: null
      },
      receiptBillList: {
        type: Array,
        default: () => {
          return []
        }
      },
      receiptBillTips: {
        type: String,
        default: ''
      },
      paymentBills: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    watch: {
      bookInfo() {
        this.bookInfos.push(this.bookInfo)
      },
      paymentBills() {
        if(this.paymentBills){
          this.dataPay = this.paymentBills
        }
      }
    },
    computed:{
      columnAccount(){
        return [
          {
            title: "开户行名称",
            key: "customerBankName",
            align: "center"

          },
          {
            title: "账户名",
            key: "customerAccountName",
            align: "center"
          },
          {
            title: "银行账号",
            key: "customerBankAccount",
            align: "center"

          }
        ]
      },
      column(){
        return [
          {
            title: "帐单编号",
            key: "billNum",
            align: "center",

          },
          {
            title: "费用项",
            key: "costCodeName",
            align: "center"
          },
          {
            title: "应收",
            key: "receiptBillAmount",
            align: "center",
            render: (h, params) => {
              return h('span', {}, (params.row['receiptBillAmount'] / 100).toFixed(2))
            }
          },
          {
            title: "已收",
            key: "receivedBillAmount",
            align: "center",
            render: (h, params) => {
              return h('span', {}, (params.row['receivedBillAmount'] / 100).toFixed(2))
            }
          },
          {
            title: "状态",
            key: "verificateStatusName",
            align: "center"
          }
        ]
      },
      columnPay(){
        return [
          ...this.othersColumns,
          {
            title: "提交时间",
            key: "createDate",
            align: "center",
            render: (h, params) => {
              return h('span', {}, formatDateTime(params.row['createDate']))
            }
          },
          {
            title: "打款时间",
            key: "payTime",
            align: "center",
            render: (h, params) => {
              return h('span', {}, formatDateTime(params.row['payTime']))
            }
          },
          {
            title: "付款状态",
            key: "payFlag",
            align: "center",
            render: (h, params) => {
              let maps = {'1': '未付款', '2': '已付款', '3': '付款异常', '4': '付款中'}
              return h('span', {}, maps[params.row['payFlag'] + ''])
            }

          },
          {
            title: "操作",
            key: "action",
            align: "center",
            render: (h, params) => {
              return h('div', [h('a', {
                // directives:[
                //   {
                //     name:'p',
                //     // value:{
                //     //   menu:'outhouse',
                //     //   api:'checkinPersion/save'
                //     // }
                //   }
                // ],
                //当状态为3付款异常时展示
                style: {
                  marginRight: '5px',
                  display: params.row.payFlag === 3 && params.index === this.dataPay.length - 1 ? 'inline-block' : 'none'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '付款异常处理',
                      content: '<p>继续操作将重新生成付款单并执行打款流程，是否继续</p>',
                      onOk: () => {
                        let params1 = {
                          busId: params.row['busId']
                        }
                        repayment(params1).then(res => {
                          this.$Message.success('操作成功')
                          this.getReservationBills()
                        }).catch(error => {
                          this.$Message.info('操作失败')
                          this.getReservationBills()
                        })

                      }
                    })
                  }
                }
              }, '重新付款'), h('a', {
                style: {
                  display: this.bookInfo && this.bookInfo.userType == 1 && params.row.payFlag === 2 ? 'inline-block' : 'none',
                  marginRight: '5px'
                },
                // directives:[
                //   {
                //     name:'p',
                //     value:{
                //       api:['certificate/savePaymentVoucher','certificate/batchSaveCertificate']
                //     }
                //   }
                // ],
                on: {
                  click: () => {
                    this.paymentFid = params.row.fid
                    this.payDetailKey++
                  }
                }
              }, '付款明细'),
              ])
            }
          }
        ]
      },
      othersColumns() {
        if (this.bookInfo && this.bookInfo.userType == 3) {
          return [{
            title: "付款单号",
            key: "billNum",
            align: "center"
          }]
        } else {
          return [

          ]
        }
      }
    },
    components:{
      PayDetail
    },
    data() {
      return {
        bookInfos: [],
        payDetailKey: 0,
        paymentFid: '',
        dataPay: []
      }
    },
    methods: {

      getReservationBills(){
        let param = {fid: this.bookInfo.fid}
        getReservationBills(param).then(res => {
          this.dataPay = res.data.paymentBills;
        }).catch(error => {

        })
      }

    }
  }
</script>

<style scoped>
 .tips1{
   margin-top: -23px;
   position: absolute;
   width: 200px;
   font-weight:bold;
   color: #f5140f;

 }
</style>
